/*
 * File: index.ts
 * File Created: 2024-02-02 07:43:38
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-02 10:28:33
 * Modified By: Val Liu
 * -----
 */

import { PARAMS_INCLUDE, PARAMS_WHERE } from "@/views/core";
import { IPermissionCheck, ObjectHelper, Vue } from "@root/core";
import { IQuickUnit, UIQuick } from "@root/core/utilities/quick-helper";

const _ = UIQuick.getInstance;

@UIQuick.set()
export class PromotionCode extends IQuickUnit {
    title = "w_MenuPromoCode";
    path = "/promotion-code";
    icon = "fa-solid fa-tag";

    /// hireachy
    parents = null;
    children = null;

    /// file
    file = false;

    /// params
    paramsWhere = PARAMS_WHERE;
    paramsRead = function(this) {
        return ObjectHelper.deepMerge(
            PARAMS_INCLUDE.call(this),
            // {
            //     include: {
            //         organization: {
            //             include: {
            //                 user: true,
            //             },
            //         },
            //         _count: {
            //             select: {
            //                 ledgers: true,
            //             },
            //         },
            //     },
            // },
        );
    };
    paramsUpdate = PARAMS_INCLUDE;

    allowUpdate = true;
    allowDelete = true;

    /// interfaces
    infDetail = require("raw-loader!./interfaces/promotion-code.create.interface").default;
    infRead = require("raw-loader!./interfaces/promotion-code.read.interface").default;
    infCreate = require("raw-loader!./interfaces/promotion-code.create.interface").default;
    infUpdate = require("raw-loader!./interfaces/promotion-code.create.interface").default;
    infDelete = require("raw-loader!./interfaces/promotion-code.delete.interface").default;
}
